import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useHistory } from "react-router-dom";

const BackButton = () => {
  const history = useHistory();

  return (
    <Button onClick={() => history.goBack()}>
      <ArrowLeft />
      Back
    </Button>
  );
};

export default BackButton;
